export default __webpack_public_path__ + "static/media/info.c9061baa.png";